// Import utilities
import {
	restCall
} from '@builder-legacy/common/utilities';

// Import utilities
const {
	isDefined
} = _uo.utility;

import { sanitizeConditionsForMeta } from '@builder-legacy/item/conditions/utilities';

import Actions from '@builder-legacy/item/actions';

/**
 * Updates the conditions saved in the recipe meta
 *
 * @param {Object}   options           The options
 * @param {Callback} options.onSuccess The callback invoked if the task is successful
 * @param {Callback} options.onFail    The callback invoked if the task is not successful
 * @return {undefined}
 */
const updateRemoteConditionsMeta = ( { onSuccess, onFail } ) => {
	// Update only if Pro is active
	if ( ! UncannyAutomator._site.automator.has_pro ) {
		return;
	}

	// Get conditions
	const conditions = sanitizeConditionsForMeta();

	UncannyAutomator._core.recipe.item.filter.updateFilters(
		JSON.stringify( conditions )
	).then( response => {
		// Check if the task was successful
		if ( ! response.success ) {
			return;
		}

		// Check if the onSuccess callback is defined
		if ( isDefined( onSuccess ) ) {
			try {
				// Clear the cache of tokens
				UncannyAutomator._cache.tokens = [];
				
				// Invoke onSuccess callback
				onSuccess( response );
			} catch ( e ) {
				if ( UncannyAutomator._site.has_debug_enabled ) {
					// eslint-disable-next-line no-console
					console.error( "updateRemoteConditionsMeta: Couldn't execute the onSuccess callback." );

					// eslint-disable-next-line no-console
					console.error( e );
				}
			}
		}
	} ).catch( error => {
		if ( UncannyAutomator._site.has_debug_enabled ) {
			// eslint-disable-next-line no-console
			console.error(
				"updateRemoteConditionsMeta: Couldn't update remote conditions meta. UI might be outdated."
			);
		}

		// Check if the onFail callback is defined
		if ( isDefined( onFail ) ) {
			try {
				// Invoke onFail callback
				onFail();
			} catch ( e ) {
				if ( UncannyAutomator._site.has_debug_enabled ) {
					// eslint-disable-next-line no-console
					console.error( "updateRemoteConditionsMeta: Couldn't execute the onFail callback." );

					// eslint-disable-next-line no-console
					console.error( e );
				}
			}
		}
	} );
};

export default updateRemoteConditionsMeta;
